<template>
  <div class="container-lg container-lg-custom">
    <div class="acciones-panel acciones-panel-custom">
      <button @click="clickNuevo()" type="button" class="btn btn-success">
        <span>Nuevo</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.AGREGAR" />
      </button>
      <Buscador :esBeneficio="esBeneficio" :onSearch="filtrarTabla"></Buscador>

      <!-- Comentar codigo de funcionalidad de ordenamiento -->
      <!-- <button
        v-if="permiteOrdenar"
        @click="ordenando = !ordenando"
        type="button"
        class="btn btn-outline-dark"
        data-bs-toggle="button"
      >
        <span v-show="!ordenando">Ordenar</span>
        <span v-show="ordenando">Ordenando</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.ORDENAR" />
      </button> -->
    </div>

    <!-- Comentar codigo de funcionalidad de ordenamiento -->
    <!-- :ordenando="ordenando && permiteOrdenar"   :puedeOrdenar="permiteOrdenar" en TablaBeneficios-->
    <TablaBeneficios ref="tablaBeneficios" id="tablaBeneficios" :comercioFijo="comercioFijo" :comercioList="comercioList"
      :tiposCodigoList="tiposCodigoList" :mostrarEditar="true" :mostrarEliminar="true" :facade="Facade"
      :permitePrioridad="true" :busqueda="busqueda" :cargaManual="true" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BeneficioFacade as Facade } from "../../admin/beneficio/beneficio.facade";
import { ComercioFacade } from "../../admin/comercio/comercio.facade";
import { Icons as IconConstants } from "../../constants";
import TablaBeneficios from "./tablas/TablaBeneficios";
import Buscador from "./tablas/util/Buscador";
import { BuscarPor, OrdenarPor } from "../../data/enums";


export default {
  components: {
    FontAwesomeIcon,

    TablaBeneficios,
    Buscador,
  },
  props: {
    /** Si es verdadero, no se podrá cambiar el comercio de los beneficios */
    comercioFijo: {
      type: Boolean,
      default: false
    },
    // Comentar codigo de funcionalidad de ordenamiento
    // permiteOrdenar: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      busqueda: {
        valor: null,
        buscarPor: BuscarPor.comercio,
        ordenarPor: OrdenarPor.relevancia
      },
      comercioList: undefined,
      //ordenando: false,
      tiposCodigoList: undefined,
      // Usado para indicarle al componente buscador que es beneficio
      esBeneficio: true,
    };
  },
  computed: {
    Facade() {
      return Facade;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    }
  },
  created() {
    ComercioFacade.getActiveList().then(response => {
      this.comercioList = response.data;
    });

    Facade.getTiposCodigo().then(response => {
      this.tiposCodigoList = response.data;
    });

  },
  methods: {
    // Cuando se quiere crear un item
    clickNuevo() {
      // Avisar que se quiere crear un item
      this.$refs.tablaBeneficios.EventoCrear();
    },
    // Filtra la tabla segun la busqueda
    filtrarTabla(busqueda) {
      this.busqueda = busqueda;
      this.$refs.tablaBeneficios.EventoRecargar(busqueda);
    }
  },
  mounted() {
    this.$refs.tablaBeneficios.EventoRecargar(this.busqueda);
  }
};
</script>

<style lang="scss" scoped>
.opciones-de-elemento {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
}

.acciones-panel {
  justify-content: space-between;
}


</style>
